import ReactDOM from 'react-dom/client'
import './main.css'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import './i18next'
import { initializeSentry } from '@/services'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import { ToastProvider, HeroUIProvider } from '@heroui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { App } from './app'

const development = import.meta.env.DEV
const posthogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY

if (!development) {
  initializeSentry()

  posthog.init(posthogApiKey, {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30',
    autocapture: false,
    before_send: (e) => {
      if (e?.properties.is_testing_ecommerce || e?.properties.is_testing_user) {
        return null
      }

      return e
    }
  })
}

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PostHogProvider client={posthog}>
    <Provider store={store}>
      <HeroUIProvider>
        <ToastProvider placement="top-center" />
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </HeroUIProvider>
    </Provider>
  </PostHogProvider>
)
